<template>
  <nav
    class="header-navigation"
    :class="{ 'header-navigation--hidden': !showHeader }">
    <div
      aria-label="primary"
      class="header-navigation__container">
      <ul class="header-navigation__list">
        <template v-if="items">
          <li v-for="(item, i) in items" :key="i">
            <a
              v-if="mq('small')"
              :href="item.url"
              class="button button-link button-link--narrow">
              {{ item.title }}
            </a>

            <a
              v-else
              :href="item.url"
              class="navigational-item navigational-item--arrow navigational-item--dark-blue navigation-slide__link">
              {{ item.title }}
            </a>
          </li>
        </template>
      </ul>
      <oie-my-machines-selector-slide-in
        v-if="hasMyMachines"
        class="header-navigation__global-machine-selector"
        @select-machine="handleSelection"
        @select-owner="handleSelection">
        <template #activator="{ open }">
          <oie-base-action v-tooltip.top="{content: tStatic('selectMachineTooltip'), classes: ['inverted']}" size="large" @click="open">
            <template #iconPrepend>
              <oie-base-icon icon="machine" size="s"></oie-base-icon>
            </template>
            {{ tStatic('selectMachine') }}
          </oie-base-action>
        </template>
      </oie-my-machines-selector-slide-in>

      <oie-my-machines-quick-add-slide-in v-else class="header-navigation__global-machine-selector" :title="tStatic('addYourFirstMachineHeading')">
        <template #activator="{ open }">
          <oie-base-action v-tooltip.top="{content: tStatic('selectMachineTooltip'), classes: ['inverted']}" size="large" @click="open">
            <template #iconPrepend>
              <oie-base-icon icon="machine" size="s"></oie-base-icon>
            </template>
            {{ tStatic('selectMachine') }}
          </oie-base-action>
        </template>
      </oie-my-machines-quick-add-slide-in>
    </div>
  </nav>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    headerNavigationHeight: null
  }),
  computed: {
    ...mapGetters('myMachines', ['hasMyMachines'])
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions('myMachines', ['myMachines', 'setGlobalMyMachinesSelection']),
    handleScroll: _.throttle(function () {
      const scrollDiff = window.scrollY - this.lastScrollPosition
      this.lastScrollPosition = window.scrollY

      const isProgrammaticScroll = Math.abs(scrollDiff) < 200 // to compensate for programmatic scoll when header is removed from DOM

      if (isProgrammaticScroll) return

      this.toggleHeader(scrollDiff)
    }, 200, { leading: false }),
    toggleHeader(scrollDiff) {
      this.showHeader = scrollDiff < 0
    },
    handleSelection(selection) {
      this.setGlobalMyMachinesSelection(selection)
    }
  }
}
</script>

<style lang="scss">
.header-navigation {
  width: 100%;
  transition: transform .4s ease;
}

.header-navigation--hidden {
  transform: translateY(-100%);
  position: absolute;
}

.header-navigation__global-machine-selector {
  margin-left: auto;
}
</style>
